import styled from 'styled-components';

const AccordionContent = styled.div`
  max-height: ${({ open }) => (open ? '100vh' : '0')};
  position: relative;
  overflow: hidden;
  ${({ open }) => (open ? 'transition: max-height 0.75s ease-in' : 'transition: max-height 0.5s ease-out')};
`;

export default AccordionContent;
